import { render, staticRenderFns } from "./coding.vue?vue&type=template&id=ded2aee0&"
import script from "./coding.vue?vue&type=script&lang=js&"
export * from "./coding.vue?vue&type=script&lang=js&"
import style0 from "./coding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports